import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import ReportStyle from "@/page-components/reporting/reporting.module.css";
import crossIcon from "@/assets/img/closecross.svg";
import styles from "@/page-components/cost-explorer/components/edit-widget/edit-widget.module.css";
import { Offcanvas, Spinner } from "react-bootstrap";
import add from "@/assets/img/add.svg";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search-without-apply";
import Joi from "joi";
import { joiResolver } from "@hookform/resolvers/joi";
import ToastComponent from "@/page-components/budgets/components/toast";
import { useGetTags } from "@/services/taggings/get-tags.repo";
import { ReportingContext } from "../reporting-context-file";
import ReportingFilterComponent from "./create-filter-component.part";
import { CreateAllCloudReport, DropdownComponent, SelectField } from "./helper";
import includeIcon from "@/assets/img/addbuttoninblue.svg";
import closeCross from "@/assets/img/closecross.svg";
import budgetStyle from "@/page-components/budgets/components/budgets.module.css";
import csv from "@/assets/img/csv.svg";
import pdf from "@/assets/img/pdf.svg";
import excel from "@/assets/img/excel.svg";
import { useCreateReport } from "@/services/reporting/create-report.repo";
import { useGetEditReportData } from "@/services/reporting/get-edit-data.repo";
import CustomCalendar from "./custom-range-calendar";
import { format, toDate } from "date-fns";

const CreateReport = ({
  service,
  deleteLoading,
  deleteSuccess,
  deleteError,
  deleteData,
}) => {
  const context = useContext(ReportingContext);
  const [tempSelectValues, setTempSelectValues] = useState([]);
  const [extractData, setExtractData] = useState([]);
  const [toast, setToast] = useState(false);
  const [message, setMessage] = useState();
  const [localEmailError, setLocalEmailError] = useState("");

  // const EditData = context?.Editdata;

  const [extractTagsData, setExtractTagsData] = useState([]);

  const filters = useMemo(() => {
    // const modifiedFormat = (selected, type, data) => {
    //   return Object.keys(selected)
    //     .filter((e) => e !== "Dimension Values" && e !== "Tag Values")
    //     .map((key) => ({
    //       name:
    //         data === extractData
    //           ? data.filter((names) => names.id === key).map((e) => e.name)[0]
    //           : key,
    //       values: selected[key].map((item) => item.id),
    //     }));
    // };

    const modifiedFormat = (selected, type, data) => {
      return Object.keys(selected)
        .filter((e) => e !== "Dimension Values" && e !== "Tag Values")
        .map((key) => ({
          name:
            data === extractData && data?.length
              ? data.find((entry) => entry.id === key)?.name || key
              : key,
          values: selected[key].map((item) => item.id),
        }));
    };

    return {
      dimensions: modifiedFormat(
        context?.selectedValues,
        "dimension",
        extractData
      ),
      tags: modifiedFormat(context?.selectedTagValues, "tags", extractTagsData),
    };
  }, [
    context?.selectedValues,
    context?.selectedTagValues,
    extractData,
    extractTagsData,
  ]);

  const query = useMemo(
    () => ({
      service: service,
      id: context.EditdataId,
    }),
    [context.EditdataId]
  );
  const {
    data: editData,
    isLoading: editLoading,
    error,
    refetch,
  } = useGetEditReportData(query, [], !!context.EditdataId);

  const clearFilterData = () => {
    context?.setSelectedTagValues([]);
    context?.setSelectedValues([]);
  };

  const HandleClose = () => {
    reset({
      NAME: "",
      PERIOD: "",
      Frequency: "",
      ALERTS_RECEIPIENTS: "",
    });

    context?.setEditdataId("");
    context?.setSelectedEmail([]);
    context?.setSelectedRadiobutton("csv");
    context?.setSelectedCreateGroupBy("");
    context?.setSelectedValues({ "Dimension Values": [] });
    context?.setSelectedTagValues({ "Tag Values": [] });
    context?.setRange?.([{ startDate: "", endDate: "", key: "selection" }]);
    context?.setSelectedDate?.(null);
    setValue("PERIOD", "");
    context?.setIsLayoverOpen(false);
    context?.setSelectedPeriod?.(null);
    context?.setSelectedColumns([]);
    context?.setExportType("default");
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitted },
    reset,
    setError,
    setValue,
    getValues,
    watch,
    resetField,
    clearErrors,
  } = useForm({
    resolver: joiResolver(CreateAllCloudReport(context)),
  });

  const queryType = useMemo(() => (editData ? "edit" : "create"), [editData]);
  let {
    mutate: Id,
    data,
    reset: createReset,
    isError,
    error: createError,
    isSuccess: successMessage,
    isPending,
  } = useCreateReport(queryType);

  const lastActionType = useRef(queryType);

  const onSubmit = (formData) => {
    lastActionType.current = queryType;

    const transformedData = {
      report_name: formData.NAME,
      period: formData.PERIOD,
      frequency: formData.Frequency,
      output_format: context?.selectedRadiobutton || "csv",
      alert_recipients: context?.SelectedEmail || [],
      filters,
      group_by: context?.selectedCreateGroupBy.toLowerCase() || "",
      start_date: context?.fromDate,
      end_date: context?.toDate,
      customize_column_type: context?.exportType.toUpperCase() || "",
      customized_columns: context?.selectedColumns || [],
    };

    Id({
      body: transformedData,
      service: service,
      id: editData?.id,
    });
  };

  const handleRemoveEmail = (index) => {
    context?.setSelectedEmail((prevRecipients) => {
      const updatedRecipients = prevRecipients.filter((_, i) => i !== index);
      setValue("ALERTS_RECEIPIENTS", updatedRecipients, {
        shouldValidate: true,
      });
      return updatedRecipients;
    });
  };

  const handleAddEmail = () => {
    const input = document.getElementById("emailInput");
    const value = input.value.trim();

    if (value) {
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

      if (!isValidEmail) {
        setLocalEmailError("Please enter a valid email address");
        setError("ALERTS_RECEIPIENTS", {
          type: "manual",
          message: "Please enter a valid email address",
        });
      } else if (
        context?.SelectedEmail?.some(
          (e) => e.toLowerCase() === value.toLowerCase()
        )
      ) {
        setLocalEmailError(
          "This email address is already added. Please enter a different email."
        );
        setError("ALERTS_RECEIPIENTS", {
          type: "manual",
          message:
            "This email address is already added. Please enter a different email.",
        });
      } else {
        setLocalEmailError("");
        clearErrors("ALERTS_RECEIPIENTS");
        context?.setSelectedEmail((prevRecipients) => {
          const updatedRecipients = [...prevRecipients, value];
          setValue("ALERTS_RECEIPIENTS", updatedRecipients, {
            shouldValidate: true,
          });
          return updatedRecipients;
        });
        input.value = "";
      }
    }
  };

  const handleCloseOverlay = () => {
    context?.setIsLayoverOpen(false);
    createReset();
    reset({
      NAME: "",
      PERIOD: "",
      Frequency: "",
    });
    clearFilterData();
    context?.setEditdataId(null);
    context?.setSelectedRadiobutton("csv");
    context?.setSelectedEmail("");
    context?.setSelectedCreateGroupBy("");
    context?.setRange?.([{ startDate: "", endDate: "", key: "selection" }]);
    context?.setSelectedDate?.(null);
    setValue("PERIOD", "");
    context?.setSelectedPeriod?.(null);
    context?.setSelectedColumns([]);
    context?.setExportType("default");
  };

  // ------------------------------------------------------------------

  const groupByOptions = [
    {
      name:
        service === "azure"
          ? "Subscription"
          : service === "gcp"
          ? "Project"
          : "Account",
      id:
        service === "azure"
          ? "subscription"
          : service === "gcp"
          ? "project"
          : "account",
    },
    {
      name: "Region",
      id: "region",
    },
    {
      name: service === "gcp" ? "Category" : "Service",
      id: service === "gcp" ? "category" : "service",
    },
  ];

  useEffect(() => {
    if (editData && !!context?.EditdataId) {
      setValue(
        "PERIOD",
        (editData?.period !== "CUSTOM" && editData?.period) || ""
      );
      setValue("Frequency", editData?.frequency || "");
      setValue("NAME", editData?.name || "");

      context?.setRange?.([{ startDate: "", endDate: "", key: "selection" }]);
      context?.setSelectedDate?.(null);

      // customized column and export type
      const columnType =
        editData?.customize_column_type?.toLowerCase() || "default";
      context?.setExportType(columnType);
      if (columnType === "custom" && editData?.customized_columns) {
        context?.setSelectedColumns(editData?.customized_columns);
      } else {
        context?.setSelectedColumns([]);
      }

      // selected E-mail
      context?.setSelectedEmail(editData?.alert_recipients || []);
      context?.setSelectedRadiobutton(
        editData?.output_format.toLowerCase() || ""
      );

      const selectedGroupById = editData?.group_by || "";

      const selectedGroupByOption = groupByOptions.find(
        (opt) => opt.id === selectedGroupById
      );

      context?.setSelectedCreateGroupBy(
        selectedGroupByOption ? selectedGroupByOption.id : undefined
      );
      setValue(
        "group_by",
        selectedGroupByOption ? selectedGroupByOption.id : undefined
      );

      // // Set dimensions

      // const initialSelectedValues = { "Dimension Values": [] };

      // (editData?.filters?.dimensions || []).forEach((dimension) => {
      //   const formattedValues = dimension.values.map((value) => ({
      //     id: value,
      //     name: value,
      //   }));

      //   initialSelectedValues[dimension.name] = formattedValues;
      //   initialSelectedValues["Dimension Values"].push(...formattedValues);
      // });

      // context?.setSelectedValues(initialSelectedValues);

      // Set tags
      const tagObj = { "Tag Values": [] };
      (editData.filters?.tags || []).forEach((t) => {
        const values = t.values.map((v) => ({ id: v, name: v }));
        tagObj[t.name] = values;
        tagObj["Tag Values"].push(...values);
      });
      context?.setSelectedTagValues(tagObj);
    }

    // custom calendar values
    if (
      editData?.period === "CUSTOM" &&
      editData?.start_date &&
      editData?.end_date
    ) {
      const startDate = new Date(editData.start_date);
      const endDate = new Date(editData.end_date);

      context?.setSelectedPeriod?.("CUSTOM");
      context?.setRange?.([{ startDate, endDate, key: "selection" }]);

      // Format in MMM yy
      const formattedRange = `${format(startDate, "MMM yy")} - ${format(
        endDate,
        "MMM yy"
      )}`;
      context?.setSelectedDate?.(formattedRange);

      setValue("PERIOD", "CUSTOM");
    } else {
      context?.setRange?.([{ startDate: "", endDate: "", key: "selection" }]);
      context?.setSelectedDate?.(null);
    }

    clearErrors("PERIOD", "NAME", "Frequency");
    clearErrors("ALERTS_RECEIPIENTS");
  }, [editData, setValue, context?.EditdataId]);

  useEffect(() => {
    if (successMessage) {
      HandleClose();

      const messageText =
        lastActionType.current === "edit"
          ? "Report updated successfully."
          : "Report created successfully.";

      setMessage({
        message: messageText,
        type: "success",
      });
      setToast(true);
      context?.refetchTable();
      createReset();
    }
  }, [successMessage, queryType]);

  // SUCCESS - Delete
  useEffect(() => {
    if (deleteSuccess) {
      HandleClose();
      context?.setConfirmationmodal(false);
      setMessage({
        message: "Report deleted successfully.",
        type: "success",
      });
      setToast(true);
      context?.refetchTable();
    }
  }, [deleteSuccess]);

  // ERROR - Create & Edit
  useEffect(() => {
    if (createError) {
      const messageText =
        lastActionType.current === "edit"
          ? "Failed to update the report. Please try again."
          : "Failed to create the report. Please try again.";

      setMessage({
        message: messageText,
        type: "Anomaly",
      });
      setToast(true);
    }
  }, [createError, queryType]);

  // ERROR - Delete
  useEffect(() => {
    if (deleteError) {
      HandleClose();
      context?.setConfirmationmodal(false);
      setMessage({
        message: "Failed to delete the report. Please try again.",
        type: "Anomaly",
      });
      setToast(true);
    }
  }, [deleteError]);

  useEffect(() => {
    register("ALERTS_RECEIPIENTS", {
      required: "ALERTS_RECEIPIENTS is required",
    });
  }, [register]);

  useEffect(() => {
    setValue("ALERTS_RECEIPIENTS", context?.SelectedEmail || [], {
      shouldValidate: true,
    });
  }, [context?.SelectedEmail, setValue]);
  // -----------------------------------------------------------------------------------------------------

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const lastNonCustomRef = useRef("LAST_WEEK");

  // 1) Ensure defaults exist in context
  useEffect(() => {
    if (!context?.SelectedPeriod) {
      context?.setSelectedPeriod?.("LAST_WEEK");
    }
    if (!context?.dropdownView) {
      context?.setDropdownView?.("main");
    }
  }, [context]);

  // 2) Handle selection in main dropdown
  const handlePeriodSelect = (ids) => {
    if (ids === "CUSTOM") {
      // store previous selection before switching
      lastNonCustomRef.current = context?.SelectedPeriod || "LAST_WEEK";
      context?.setSelectedPeriod?.("CUSTOM");
      context?.setDropdownView?.("customRange");
      setIsDropdownOpen(true);
      // setValue("Frequency", "ONE_TIME");
    } else {
      context?.setSelectedPeriod?.(ids);
      context?.setDropdownView?.("main");
      setIsDropdownOpen(false);
    }
  };

  // 3) Back button from custom range
  const handleBackClick = () => {
    context?.setDropdownView?.("main");

    // reset custom calendar state
    context?.setRange?.([{ startDate: "", endDate: "", key: "selection" }]);
    context?.setSelectedDate?.(null);


    context?.setSelectedPeriod?.(null);
    setValue("PERIOD", "");
  };

  // 4) Toggle for custom dropdown
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  // 5) Close custom dropdown if clicking outside
  useEffect(() => {
    const onClickAway = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickAway);
    return () => document.removeEventListener("mousedown", onClickAway);
  }, []);

  useEffect(() => {
    if (context?.SelectedPeriod === "CUSTOM" && !editData) {
      setValue("Frequency", "");
    }
  }, [context?.SelectedPeriod, editData, setValue]);

  // useEffect(() => {
  //   if (context?.SelectedPeriod === "CUSTOM") {
  //     const currentFrequency = getValues("Frequency");
  //     if (currentFrequency !== "ONE_TIME") {
  //       setValue("Frequency", "ONE_TIME");
  //     }
  //   }
  // }, [context?.SelectedPeriod, getValues, setValue]);


  return (
    <>
      {toast && (
        <ToastComponent
          message={message}
          toast={toast}
          setToast={setToast}
          timeout={5000}
        />
      )}

      <Offcanvas
        placement="end"
        show={context?.isLayoverOpen}
        onHide={() => {
          HandleClose();
        }}
        style={{
          width: "50%",
        }}
      >
        {editLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100vh",
            }}
          >
            <Spinner />
          </div>
        )}

        {!editLoading && (
          <>
            <Offcanvas.Header className={ReportStyle.offcanvas_headed}>
              <div className={ReportStyle?.create_div}>
                {" "}
                <div className={ReportStyle.head_cross_sign}>
                  <span className={ReportStyle.Heading_Cross}>
                    {editData ? "Edit" : "Create"} Report
                  </span>
                  <img
                    src={crossIcon}
                    alt=""
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      HandleClose();
                    }}
                  />
                </div>
                <span className={ReportStyle?.repoting_desc}>
                  Generate detailed cost reports and manage alerts with
                  customizable notifications.
                </span>
              </div>
            </Offcanvas.Header>

            <Offcanvas.Body
              className={styles.modal_body}
              style={{ padding: "24px", gap: "24px" }}
            >
              <form
                onSubmit={handleSubmit(onSubmit)}
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                {/* -----------------------------filters -dimension & tags---------------------------------- */}
                <div>
                  <ReportingFilterComponent
                    service={service ?? "all-cloud"}
                    rules={errors}
                    control={control}
                    setValue={setValue}
                    tempSelectValues={tempSelectValues ?? []}
                    setTempSelectValues={setTempSelectValues ?? (() => {})}
                    setExtractData={setExtractData ?? (() => {})}
                    clearFilterData={clearFilterData ?? false}
                    extractTagsData={extractTagsData}
                    setExtractTagsData={context?.setSelectedTagValues}
                    editData={editData}
                    groupByOptions={groupByOptions}
                    disabled={!!editData}
                  />
                </div>
                {/* -------------------------------name, period, frequency------------------------------------------ */}
                <div className="budget_account_box">
                  <div className="budget_account">
                    <div className="budget_name">Report Details</div>
                    <div className="budget_discription">
                      Give your report a unique name. Set the date range and
                      granularity for the data to be analyzed.
                    </div>
                  </div>

                  <div className="charge_select">
                    <div className="accountid_box">
                      <div className="accountid_name">
                        Name
                        <span className="astriek_css">
                          <b> *</b>
                        </span>
                      </div>
                      <div>
                        <input
                          className="input_box_css"
                          name="NAME"
                          placeholder="Enter a unique name"
                          {...register("NAME")}
                          style={{ color: "#000" }}
                        />
                      </div>
                      <div style={{ height: "10px", display: "flex" }}>
                        {errors.NAME && (
                          <span className="budgetsError">
                            {errors.NAME.message}
                          </span>
                        )}
                      </div>
                    </div>
                    <span className="semicolon_css"></span>

                    {context?.SelectedPeriod !== "CUSTOM" && (
                      <SelectField
                        control={control}
                        rules={errors.PERIOD}
                        title={"Period"}
                        placeholder={"Select Period"}
                        fieldName="PERIOD"
                        service={service}
                        disabled={!!editData}
                        commonFieldData={[
                          { id: "LAST_WEEK", name: "Last week" },
                          { id: "THIS_WEEK", name: "This week" },
                          { id: "THIS_MONTH", name: "This Month" },
                          { id: "LAST_MONTH", name: "Last Month" },
                          { id: "THIS_QUARTER", name: "This Quarter" },
                          { id: "CUSTOM", name: "Custom Range" },
                        ]}
                        value={context?.SelectedPeriod || "LAST_WEEK"}
                        onSelect={handlePeriodSelect}
                      />
                    )}

                    {context?.SelectedPeriod === "CUSTOM" && (
                      <DropdownComponent
                      rules={errors}
                        dropdownRef={dropdownRef}
                        title={context?.selectedDate || "Custom Range"}
                        options={[]}
                        onSelect={handleBackClick}
                        onToggle={toggleDropdown}
                        isOpen={isDropdownOpen}
                        disabled={!!editData}
                        extraButton={{
                          label: "Custom Month Range",
                          onClick: handleBackClick,
                          imgBefore: true,
                        }}
                      >
                        <div
                          style={{
                            borderBottom: "1px solid #F8F9FA",
                            marginBottom: "16px",
                            marginTop: "8px",
                          }}
                        />
                        <CustomCalendar
                          range={context?.range}
                          setRange={context?.setRange}
                          setIsDropdownOpen={setIsDropdownOpen}
                          disabled={!!editData}
                          setValue={setValue}
                        />
                      </DropdownComponent>
                    )}
                  </div>
                  <SelectField
                    control={control}
                    rules={errors.Frequency}
                    title={"Frequency"}
                    placeholder={"Select Frequency"}
                    fieldName="Frequency"
                    service={service}
                    disabled={!!editData}
                    commonFieldData={
                      context?.SelectedPeriod === "CUSTOM"
                        ? [{ id: "ONE_TIME", name: "One time" }]
                        : [
                            { id: "ONE_TIME", name: "One time" },
                            { id: "WEEKLY", name: "Weekly" },
                            { id: "MONTHLY", name: "Monthly" },
                          ]
                    }
                  />
                </div>
                {/* --------------------------------------report format--------------------------------------------- */}
                <div className={ReportStyle.reporting_fomat}>
                  <div className="budget_account">
                    <div className="budget_name">Report Output Format</div>
                    <div className="budget_discription">
                      Select the desired format to receive the report.
                    </div>
                  </div>
                  <div>
                    <div className={ReportStyle.radiobutton_div}>
                      <RadioButton
                        name="csv"
                        value="csv"
                        contextKey="selectedRadiobutton"
                        disabled={!!editData}
                        title={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <img src={csv} alt="CSV" width="16" height="16" />
                            CSV
                          </span>
                        }
                      />
                      <RadioButton
                        name="pdf"
                        value="pdf"
                        contextKey="selectedRadiobutton"
                        disabled={!!editData}
                        title={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <img src={pdf} alt="PDF" width="16" height="16" />
                            PDF
                          </span>
                        }
                      />
                      <RadioButton
                        name="excel"
                        value="excel"
                        contextKey="selectedRadiobutton"
                        disabled={!!editData}
                        title={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <img
                              src={excel}
                              alt="Excel"
                              width="16"
                              height="16"
                            />
                            Excel
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
                {/* ------------------------------------------Alert recipients (email)*----------------------------- */}
                <div
                  className="budget_account_box"
                  style={{ paddingTop: "16px" }}
                >
                  <div className="budget_account">
                    <div className="budget_name">
                      Alert recipients (email)
                      <span className="astriek_css">
                        <b> *</b>
                      </span>
                    </div>
                  </div>
                  <div className="accountid_box" style={{ gap: "7px" }}>
                    {/* <div className="accountid_name"></div> */}
                    <div style={{ display: "flex" }}>
                      <div>
                        <div>
                          <input
                            id="emailInput"
                            type="email"
                            disabled={!!editData}
                            className="input_box_css"
                            // name="ALERTS_RECEIPIENTS"
                            placeholder="example@email.com"
                            // {...register("ALERTS_RECEIPIENTS")}
                          />
                        </div>
                        <div style={{ height: "10px", display: "flex" }}>
                          {localEmailError ? (
                            <p className="budgetsError">{localEmailError}</p>
                          ) : (
                            isSubmitted &&
                            errors.ALERTS_RECEIPIENTS &&
                            context?.SelectedEmail?.length === 0 && (
                              <p className="budgetsError">
                                {errors.ALERTS_RECEIPIENTS.message}
                              </p>
                            )
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          marginLeft: "16px",
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                          cursor: "pointer",
                          marginBottom: "12px",
                        }}
                        onClick={handleAddEmail}
                      >
                        <img
                          style={{
                            width: "12px",
                            opacity: !!editData ? 0.2 : 1,
                          }}
                          src={!!editData ? add : includeIcon}
                          alt=""
                        />
                        <span
                          style={{
                            color: !!editData ? "#ced4da" : "#056EE5",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                        >
                          Add Email
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      {(context?.SelectedEmail || []).map(
                        (recipient, index) => (
                          <div
                            key={index}
                            className={budgetStyle.badgeContainers}
                          >
                            <span
                              key={index}
                              className={budgetStyle.badgesValues}
                            >
                              <span className={budgetStyle.badgeSelectedValue}>
                                {recipient}
                              </span>
                              <span>
                                <img
                                  src={closeCross}
                                  alt="crossIcon"
                                  // onClick={() => handleRemoveEmail(index)}
                                  style={{
                                    cursor: editData ? "" : "pointer",
                                    opacity: editData ? 0.5 : 1,
                                  }}
                                  onClick={() => {
                                    if (!editData) handleRemoveEmail(index);
                                  }}
                                />
                              </span>
                            </span>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
                {/* -----------------------------------cancel, create, delete buttons----------------------------- */}
                <div
                  className="button_box"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "24px",
                    marginLeft: "-24px",
                    marginRight: "-24px",
                    borderTop: "1px solid #ccc",
                  }}
                >
                  <div>
                    {editData && (
                      <button
                        type="button"
                        style={{ cursor: "pointer" }}
                        className="delete_button"
                        onClick={() => {
                          context?.setConfirmationmodal(true);
                          context?.setDeleteData(editData?.id);
                        }}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                  <div className="cancel_create_button">
                    <button
                      type="button"
                      style={{ cursor: "pointer" }}
                      className="cancel_button"
                      onClick={() => {
                        handleCloseOverlay();
                      }}
                    >
                      Cancel
                    </button>
                    {editData && (
                      <button type="submit" className="create_button">
                        {isPending ? "Updating..." : "Update"}
                      </button>
                    )}
                    {!editData && (
                      <button type="submit" className="create_button">
                        {isPending ? "Creating..." : "Create"}
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </Offcanvas.Body>
          </>
        )}
      </Offcanvas>
    </>
  );
};

export default CreateReport;

export const RadioButton = ({ name, title, value, contextKey, disabled }) => {
  const context = useContext(ReportingContext);

  const handleChange = (e) => {
    const newValue = e.target.value;

    context?.setSelectedRadiobutton(newValue);
  };

  return (
    <div className="radioButtonSection">
      <input
        style={{ cursor: "pointer" }}
        type="radio"
        name={name}
        id={value}
        value={value}
        checked={context?.[contextKey] === value}
        onChange={handleChange}
        disabled={disabled}
      />
      <label htmlFor={value} style={{ cursor: "pointer" }}>
        {title}
      </label>
    </div>
  );
};
